import { defineStore } from "pinia";

export default defineStore("courseState", {
  state: () => ({
    site: null,
    title: null,
    licenceId: null,
  }),
});
